/**
 * 国家/地区列表数据
 *
 * 主要导出：`COUNTRIES` 常量数组
 *
 * 用途：
 * - 客户创建/编辑表单中的国家下拉选择器数据源
 * - 被 `<crm-quick-create-customer>` 等组件引用
 *
 * 数据结构：每项包含 `id`（数字标识，与后端 nation_id 对应）和 `name`（英文名称）
 * 注意：列表共 234 个国家/地区，ID 从 1 递增
 */
export const COUNTRIES = [
  { id: 1, name: "Afghanistan" },
  { id: 2, name: "Albania" },
  { id: 3, name: "Algeria" },
  { id: 4, name: "American Samoa" },
  { id: 5, name: "Andorra" },
  { id: 6, name: "Angola" },
  { id: 7, name: "Anguilla" },
  { id: 8, name: "Antarctica" },
  { id: 9, name: "Antigua and Barbuda" },
  { id: 10, name: "Argentina" },
  { id: 11, name: "Armenia" },
  { id: 12, name: "Aruba" },
  { id: 13, name: "Australia" },
  { id: 14, name: "Austria" },
  { id: 15, name: "Azerbaijan" },
  { id: 16, name: "Bahamas" },
  { id: 17, name: "Bahrain" },
  { id: 18, name: "Bangladesh" },
  { id: 19, name: "Barbados" },
  { id: 20, name: "Belarus" },
  { id: 21, name: "Belgium" },
  { id: 22, name: "Belize" },
  { id: 23, name: "Benin" },
  { id: 24, name: "Bermuda" },
  { id: 25, name: "Bhutan" },
  { id: 26, name: "Bolivia" },
  { id: 27, name: "Bosnia and Herzegovina" },
  { id: 28, name: "Botswana" },
  { id: 29, name: "Brazil" },
  { id: 30, name: "Brunei Darussalam" },
  { id: 31, name: "Bulgaria" },
  { id: 32, name: "Burkina Faso" },
  { id: 33, name: "Burundi" },
  { id: 34, name: "Cambodia" },
  { id: 35, name: "Cameroon" },
  { id: 36, name: "Canada" },
  { id: 37, name: "Cape Verde" },
  { id: 38, name: "Cayman Islands" },
  { id: 39, name: "Central African Republic" },
  { id: 40, name: "Chad" },
  { id: 41, name: "Chile" },
  { id: 42, name: "China" },
  { id: 43, name: "Christmas Island" },
  { id: 44, name: "Cocos (Keeling) Islands" },
  { id: 45, name: "Colombia" },
  { id: 46, name: "Comoros" },
  { id: 47, name: "Congo" },
  { id: 48, name: "Cook Islands" },
  { id: 49, name: "Costa Rica" },
  { id: 50, name: "Croatia" },
  { id: 51, name: "Cyprus" },
  { id: 52, name: "Czech Republic" },
  { id: 53, name: "Côte D'ivoire (Ivory Coast)" },
  { id: 54, name: "Denmark" },
  { id: 55, name: "Djibouti" },
  { id: 56, name: "Dominica" },
  { id: 57, name: "Dominican Republic" },
  { id: 58, name: "Ecuador" },
  { id: 59, name: "Egypt" },
  { id: 60, name: "El Salvador" },
  { id: 61, name: "Equatorial Guinea" },
  { id: 62, name: "Estonia" },
  { id: 63, name: "Ethiopia" },
  { id: 64, name: "Falkland Islands" },
  { id: 65, name: "Faroe Islands" },
  { id: 66, name: "Fiji" },
  { id: 67, name: "France" },
  { id: 68, name: "French Guiana" },
  { id: 69, name: "French Polynesia" },
  { id: 70, name: "French Southern Territories" },
  { id: 71, name: "Gabon" },
  { id: 72, name: "Georgia" },
  { id: 73, name: "Germany" },
  { id: 74, name: "Ghana" },
  { id: 75, name: "Gibraltar" },
  { id: 76, name: "Great Britain" },
  { id: 77, name: "Greece" },
  { id: 78, name: "Greenland" },
  { id: 79, name: "Grenada" },
  { id: 80, name: "Guadeloupe" },
  { id: 81, name: "Guam" },
  { id: 82, name: "Guatemala" },
  { id: 83, name: "Guinea" },
  { id: 84, name: "Guinea-Bissau" },
  { id: 85, name: "Guyana" },
  { id: 86, name: "Haiti" },
  { id: 87, name: "Holy See" },
  { id: 88, name: "Honduras" },
  { id: 89, name: "Hong Kong" },
  { id: 90, name: "Hungary" },
  { id: 91, name: "Iceland" },
  { id: 92, name: "India" },
  { id: 93, name: "Indonesia" },
  { id: 94, name: "Iran (Islamic Republic of)" },
  { id: 95, name: "Iraq" },
  { id: 96, name: "Ireland" },
  { id: 97, name: "Israel" },
  { id: 98, name: "Italy" },
  { id: 99, name: "Ivory Coast" },
  { id: 100, name: "Jamaica" },
  { id: 101, name: "Japan" },
  { id: 102, name: "Jordan" },
  { id: 103, name: "Kazakhstan" },
  { id: 104, name: "Kenya" },
  { id: 105, name: "Kinshasa" },
  { id: 106, name: "Kiribati" },
  { id: 107, name: "Kosovo" },
  { id: 108, name: "Kuwait" },
  { id: 109, name: "Kyrgyzstan" },
  { id: 110, name: "Lao, People's Democratic Republic" },
  { id: 111, name: "Latvia" },
  { id: 112, name: "Lebanon" },
  { id: 113, name: "Lesotho" },
  { id: 114, name: "Liberia" },
  { id: 115, name: "Libya" },
  { id: 116, name: "Liechtenstein" },
  { id: 117, name: "Lithuania" },
  { id: 118, name: "Luxembourg" },
  { id: 119, name: "Macau" },
  { id: 120, name: "Macedonia, Rep. of" },
  { id: 121, name: "Madagascar" },
  { id: 122, name: "Malawi" },
  { id: 123, name: "Malaysia" },
  { id: 124, name: "Maldives" },
  { id: 125, name: "Mali" },
  { id: 126, name: "Malta" },
  { id: 127, name: "Marshall Islands" },
  { id: 128, name: "Martinique" },
  { id: 129, name: "Mauritania" },
  { id: 130, name: "Mauritius" },
  { id: 131, name: "Mayotte" },
  { id: 132, name: "Mexico" },
  { id: 133, name: "Micronesia, Federal States of" },
  { id: 134, name: "Moldova, Republic of" },
  { id: 135, name: "Monaco" },
  { id: 136, name: "Mongolia" },
  { id: 137, name: "Montenegro" },
  { id: 138, name: "Montserrat" },
  { id: 139, name: "Morocco" },
  { id: 140, name: "Mozambique" },
  { id: 141, name: "Myanmar, Burma" },
  { id: 142, name: "Namibia" },
  { id: 143, name: "Natalia Petra TOMI" },
  { id: 144, name: "Nepal" },
  { id: 145, name: "Netherlands" },
  { id: 146, name: "Netherlands Antilles" },
  { id: 147, name: "New Caledonia" },
  { id: 148, name: "New Zealand" },
  { id: 149, name: "Nicaragua" },
  { id: 150, name: "Niger" },
  { id: 151, name: "Nigeria" },
  { id: 152, name: "Niue" },
  { id: 153, name: "North Korea" },
  { id: 154, name: "Northern Mariana Islands" },
  { id: 155, name: "Norway" },
  { id: 156, name: "Oman" },
  { id: 157, name: "Pakistan" },
  { id: 158, name: "Palau" },
  { id: 159, name: "Palestinian territories" },
  { id: 160, name: "Panama" },
  { id: 161, name: "Papua New Guinea" },
  { id: 162, name: "Paraguay" },
  { id: 163, name: "Peru" },
  { id: 164, name: "Philippines" },
  { id: 165, name: "Pitcairn Island" },
  { id: 166, name: "Poland" },
  { id: 167, name: "Portugal" },
  { id: 168, name: "Puerto Rico" },
  { id: 169, name: "Qatar" },
  { id: 170, name: "Reunion Island" },
  { id: 171, name: "Romania" },
  { id: 172, name: "Russian Federation" },
  { id: 173, name: "Rwanda" },
  { id: 174, name: "Saint Kitts and Nevis" },
  { id: 175, name: "Saint Lucia" },
  { id: 176, name: "Saint Vincent and the Grenadines" },
  { id: 177, name: "Samoa" },
  { id: 178, name: "San Marino" },
  { id: 179, name: "Sao Tome and Principe" },
  { id: 180, name: "Saudi Arabia" },
  { id: 181, name: "Senegal" },
  { id: 182, name: "Serbia" },
  { id: 183, name: "Seychelles" },
  { id: 184, name: "Sierra Leone" },
  { id: 185, name: "Singapore" },
  { id: 186, name: "Slovakia (Slovak Republic)" },
  { id: 187, name: "Slovenia" },
  { id: 188, name: "Solomon Islands" },
  { id: 189, name: "Somalia" },
  { id: 190, name: "South Africa" },
  { id: 191, name: "South Korea" },
  { id: 192, name: "South Sudan" },
  { id: 193, name: "Spain" },
  { id: 194, name: "Sri Lanka" },
  { id: 195, name: "Sudan" },
  { id: 196, name: "Suriname" },
  { id: 197, name: "Swaziland" },
  { id: 198, name: "Sweden" },
  { id: 199, name: "Switzerland" },
  { id: 200, name: "Syria, Syrian Arab Republic" },
  { id: 201, name: "Taiwan" },
  { id: 202, name: "Tajikistan" },
  { id: 203, name: "Tanzania" },
  { id: 204, name: "Thailand" },
  { id: 205, name: "Tibet" },
  { id: 206, name: "Timor-Leste (East Timor)" },
  { id: 207, name: "Togo" },
  { id: 208, name: "Tokelau" },
  { id: 209, name: "Tonga" },
  { id: 210, name: "Trinidad and Tobago" },
  { id: 211, name: "Tunisia" },
  { id: 212, name: "Turkey" },
  { id: 213, name: "Turkmenistan" },
  { id: 214, name: "Turks and Caicos Islands" },
  { id: 215, name: "Tuvalu" },
  { id: 216, name: "Uganda" },
  { id: 217, name: "Ukraine" },
  { id: 218, name: "United Arab Emirates" },
  { id: 219, name: "United Kingdom" },
  { id: 220, name: "United States" },
  { id: 221, name: "Uruguay" },
  { id: 222, name: "Uzbekistan" },
  { id: 223, name: "Vanuatu" },
  { id: 224, name: "Vatican City State (Holy See)" },
  { id: 225, name: "Venezuela" },
  { id: 226, name: "Vietnam" },
  { id: 227, name: "Virgin Islands (British)" },
  { id: 228, name: "Virgin Islands (U.S.)" },
  { id: 229, name: "Wallis and Futuna Islands" },
  { id: 230, name: "Western Sahara" },
  { id: 231, name: "Yemen" },
  { id: 232, name: "Zambia" },
  { id: 233, name: "Zimbabwe" },
  { id: 234, name: "finland" },
];
